import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CommonConstants } from '../../../../../common/constants/common-constants';
import { QuickCallDetailInfo, GroupTemplateReqParameters } from '../model/quickcallresponse';
import { RequestResponse } from '../../reportincident/model/reportincident.response';
import { CreatedRequestResponse } from '../../reportincident/model/createdrequestresponse';

@Injectable()
export class QuickCallDetailService {
    constructor(public http: HttpClient) {
    }

    // function call to fetch Quick Call detail
    public getQuickCallDetail(quickcallid: number, quickCallType: String ) {
        return this.http.get<QuickCallDetailInfo>(CommonConstants.SERVICE_VERSION_PATH_V1 +
             '/customer/quickcall/' + quickcallid + '?quickCallType=' + quickCallType );
    }

    // Post service to create incident from quick call
    public createRequest(quickcallid: number, requestResponse: RequestResponse) {
        return this.http
            .post<CreatedRequestResponse>(CommonConstants.SERVICE_VERSION_PATH_V1 +
             '/customer/quickcall/request/quickCall/' + quickcallid,
             requestResponse);
    }

    // Post service to create request from group quick call
    public createRequestFromGroupQuickcall(groupquickcallid: number, requestResponse: GroupTemplateReqParameters) {
        return this.http
            .post<number[]>(CommonConstants.SERVICE_VERSION_PATH_V1 +
             '/customer/quickcall/request/groupQuickCall/' + groupquickcallid,
             requestResponse);
    }
}
